module.exports = __webpack_public_path__ + "./fonts/BasierCircle-Bold.ttf";